var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { WorkstreamCard } from './workstream-card';
import { usePageEntity } from '../hooks';
var cls = classNames('slice-workstreams');
export var SliceWorkstreamsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var WorkstreamsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceWorkstreams',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Workstreams: styled(WorkstreamCard)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), WorkstreamsStyles)
};
export var SliceWorkstreams = function (props) {
  var _a = useComponentProps(My.NAME, SliceWorkstreamsDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity;
  var activeEntity = usePageEntity();
  var _b = activeEntity.activities,
    activities = _b === void 0 ? [] : _b;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, activities.map(function (workstream, index) {
    return React.createElement(My.Workstreams, {
      hasBottomBorder: false,
      key: workstream.id,
      number: index + 1,
      entity: workstream
    });
  }), children);
};
SliceWorkstreams.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;